import styled from 'styled-components';
import tw, { classnames, flexWrap, padding, fontSize, borderWidth, borderColor, display, space, alignItems, textColor, fontWeight, fontStyle } from 'tailwindcss-classnames';
import { TTheme } from '../../../types/common';

export const ResourceContainer = styled.div.attrs({
    className: classnames(flexWrap('flex-wrap'), padding('pb-4'))
})``;

export const ResourceItem = styled.div.attrs({
    className: classnames(borderColor('dark:border-gray-700' as any), flexWrap('flex-wrap'), fontSize('text-sm'), borderWidth('border-b'))
})``;

const ResourceItemHeaderBase = classnames(display('flex'), space('space-y-1'), alignItems('items-center'));
export const ResourceItemHeaderContainer = (theme: TTheme) => styled.div.attrs({
        className: classnames(ResourceItemHeaderBase, theme === 'light' ? textColor('dark:text-gpas-300' as any) : textColor('text-white'))
})``;

export const ResourceItemHeader = styled.h4.attrs({
    className: classnames(padding('py-0', 'pt-2'), fontWeight('font-bold'))
})`padding-top: 0px`;

export const FileItem = styled.div.attrs({
    className: classnames(display('flex'))
})``;

export const FileItemEmptyMessage = styled.span.attrs({
    className: classnames(fontStyle('italic'))
})``;
